export default __webpack_public_path__ + "static/media/P-044.7898d547.png";